export default __webpack_public_path__ + "static/bg-71685bf2a07709bf9da6a3087586e616.svg";